<template>
	<div id="login">
		<v-header :selectedItemVal="0" ref="header"></v-header>
		
		<div class="main"></div>
	</div>
</template>

<script>
	import vHeader from '../common/header'
	export default{
		name:'login',
		data(){
			return {
				
			}
		},
		components:{
			'v-header':vHeader
		},
		methods:{
			
		}
	}
</script>

<style>
	.denglu {
		display: inline-block;
		vertical-align: middle;
	}
	.denglu img {
		width: 25px;
		display: inline-block;
		/* vertical-align: 14px; */
	}
	.denglu .shuxian {
		display: inline-block;
		width: 2px;
		height: 20px;
		background: #B5B5B5;
		margin: 0 5px;
		vertical-align: text-bottom;
	}
	.zhuce:hover {
	cursor:pointer
	}
	.my-info-dialog .el-dialog__header .el-dialog__title{
		line-height: 24px;
		float: left;
		font-size: 18px;
		color: #303133;
	}
	.numberInput >>> .el-input__inner{
		padding: 0 40px;
		position: relative;
	}
	.img1 {
		position: absolute;
		top: 7px;
		left: -45px;
		z-index: 200;
		width: 25px;
		height: 25px;
	}
	.footer{
		float: right;
	}
	.edit-diog >>> .el-dialog__body{
		padding: 30px 30px 40px 0;
	}
	.edit-diog >>> .el-dialog{
		border-radius: 10px;
	}
	.step1{
		width: 80%;
		margin: 0 20px 20px 60px;
	}
	.step2{
		width: 80%;
		height: 85px;
		
		margin: 0 20px 20px 60px;
	}
	
	
	
	.after_login{
		margin: 0 auto;
	}
	
	.wallet-balance .balance-text{
		position: relative;
	}
	.wallet-balance .balance-unit img{
		position: absolute;
		width: 20%;
		right: -1.25rem;
		top: 3.125rem;
	}
	
	
	
	/* 新改动 */
	.modal-content {
	    position: relative;
	    background-color: #fff;
	    -webkit-background-clip: padding-box;
	    background-clip: padding-box;
	    border: 1px solid #999;
	    border: 1px solid rgba(0, 0, 0, .2);
	    border-radius: 6px;
	    outline: 0;
	    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
	    box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
	}
	
	.Width_1 {
	    width: 400px;
	    position: absolute;
	    top: 50%;
	    left: 50%;
	    z-index: 3;
	    margin: auto;
	    -webkit-transform: translate(-50%, -50%) !important;
	    -moz-transform: translate(-50%, -50%) !important;
	    -ms-transform: translate(-50%, -50%) !important;
	    -o-transform: translate(-50%, -50%) !important;
	    transform: translate(-50%, -50%) !important;
	}
	
	.el-dialog>.#banner {
		height: 370px;
		border-radius: 5px;
	}
	.modal-title {
	    padding: 25px 15px 0px;
	}
	.modal-title>h1 {
	    font-size: 24px;
	    font-weight: 500;
	    display: inline-block;
	    float: left;
	}
	.modal-title #moddel {
	    color: #E4343C;
	    font-size: 14px;
	    float: right;
	    margin-top: 14px;
	}
	.modal-body {
	    position: relative;
	    padding: 15px;
	}
	.form-group {
	    position: relative;
	    margin-bottom: 0.9375rem;
	}
	.text-center {
	    text-align: center;
	}
	.form-group ul {
	    padding: 15px 0;
	    position: relative;
	    z-index: 9;
	}
	
	.point-1 {
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -367px;
	    background-size: 32px 544px;
	    width: 26px;height: 33px;position: absolute;cursor: pointer;background-repeat: no-repeat;
	  }
	  .point-2 {
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -403px;
	    background-size: 32px 544px;
	    width: 26px;height: 33px;position: absolute;cursor: pointer;background-repeat: no-repeat;
	  }
	
	  .point-3 {
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -439px;
	    background-size: 32px 544px;
	    width: 26px;height: 33px;position: absolute;cursor: pointer;background-repeat: no-repeat;
	  }
	
	
	  .checkSuccessItem{
	    margin-right: 5px;
	    width: 17px;
	    height: 12px;
	    vertical-align: middle;
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -67px;
	    background-size: 32px 544px;
	
	  }
	
	
	  .refreshItem{
	    position: absolute;
	    right: 0;
	    top: 0;
	    max-width: 68px;
	    z-index: 2;
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -266px;
	    background-size: 32px 544px;
	    float: right;
	    width: 30px;
	    height: 30px;
	    margin-left: 4px;
	    cursor: pointer;
	  }
	
	
	  .revolveItem{
	    background-image: url("../../assets/img/icon_light.4353d81.png");
	    background-position: 0 -332px;
	    background-size: 32px 544px;
	    animation: loading .8s linear infinite;
	    width: 32px;
	    height: 32px;
	    background-repeat: no-repeat;
	    text-align: center;
	  }
</style>



// WEBPACK FOOTER //
// src/components/user/login.vue